import { MantineColorsTuple } from "@mantine/core";

// VenueBoards Brand Colors
export const venueBoardsBlue: MantineColorsTuple = [
  "#e8f4fd",
  "#d0e7fb",
  "#9ecef7",
  "#68b3f3",
  "#3d9cef",
  "#228eed",
  "#1086ee",
  "#0074d4",
  "#0067be",
  "#005aa8",
];

export const venueBoardsGreen: MantineColorsTuple = [
  "#e8faf0",
  "#d2f4e0",
  "#a3e8c1",
  "#70dc9f",
  "#48d182",
  "#2fcb6f",
  "#24c965",
  "#1ab252",
  "#129f47",
  "#038a39",
];

export const venueBoardsOrange: MantineColorsTuple = [
  "#fef4e6",
  "#fce7cc",
  "#f7ce9a",
  "#f2b464",
  "#ee9d37",
  "#ec9119",
  "#ec8b09",
  "#d17700",
  "#bb6a00",
  "#a45c00",
];

export const venueBoardsRed: MantineColorsTuple = [
  "#ffe8e8",
  "#ffd1d1",
  "#fba2a2",
  "#f76f6f",
  "#f44545",
  "#f22a2a",
  "#f21a1a",
  "#d80c0c",
  "#c10606",
  "#a90000",
];

export const venueBoardsGray: MantineColorsTuple = [
  "#f8f9fa",
  "#e9ecef",
  "#dee2e6",
  "#ced4da",
  "#adb5bd",
  "#6c757d",
  "#495057",
  "#343a40",
  "#212529",
  "#16191d",
];

// Semantic Colors for VenueBoards
export const semanticColors = {
  // Venue related
  arena: venueBoardsBlue[6],
  dressingRoom: venueBoardsGreen[6],
  conferenceRoom: venueBoardsOrange[6],
  kitchen: venueBoardsRed[6],

  // Event status
  confirmed: venueBoardsGreen[6],
  pending: venueBoardsOrange[6],
  cancelled: venueBoardsRed[6],
  maintenance: venueBoardsGray[6],

  // Display related
  online: venueBoardsGreen[6],
  offline: venueBoardsRed[6],
  connecting: venueBoardsOrange[6],

  // Time slots
  available: venueBoardsGreen[1],
  occupied: venueBoardsRed[1],
  break: venueBoardsGray[1],

  // Emergency
  emergency: venueBoardsRed[7],
  warning: venueBoardsOrange[7],
  info: venueBoardsBlue[7],
  success: venueBoardsGreen[7],
} as const;

export const colorPalette = {
  primary: venueBoardsBlue,
  secondary: venueBoardsGreen,
  accent: venueBoardsOrange,
  danger: venueBoardsRed,
  neutral: venueBoardsGray,
  semantic: semanticColors,
} as const;
